module.exports = __webpack_public_path__ + "assets/arcadeweb0.jpg?af6d166a7524469f919bfa21b4429a78";